module.exports = __webpack_public_path__ + "img/header.ffbb7ab2.png";